import type { ReactNode } from 'react'
import { SectionHeader } from '@/shared/ui/section-header'

interface FormSectionCardProps {
  title: string
  /** Right side of the header, usually the section's "Save" button (edit page only). */
  action?: ReactNode
  children: ReactNode
}

/** White card with a titled header shared by every section of the tour form. */
export function FormSectionCard({ title, action, children }: FormSectionCardProps) {
  return (
    <div className="bg-white rounded-2xl border border-zinc-200 p-6 lg:p-7">
      <div className="mb-4 flex items-center justify-between gap-3">
        <SectionHeader title={title} />
        {action}
      </div>
      {children}
    </div>
  )
}
